<template>
  <p v-if="text.length > maxLength" v-b-tooltip.hover :title="text">
    {{ text.substring(0, maxLength) }}...
  </p>
  <p v-else>{{ text }}</p>
</template>

<script>
export default {
  name: 'TruncatedString',
  props: { text: String, maxLength: Number },
};
</script>

<style scoped></style>
